import React, { useState } from "react";
import VStack from "../../ui_atoms/VStack";
import CodeField from "../../components/CodeField";
import type { Meta, StoryObj } from "@storybook/react";

function CodeFieldStoryComponent() {
    const [value, setValue] = useState("");

    return (
        <VStack gap={0.5} style={{ padding: 10, alignSelf: "stretch", alignItems: "stretch" }}>
            <CodeField value={value} setValue={setValue} cellCount={6} autoFocus />
        </VStack>
    );
}

const meta = {
    title: "Fields/Code",
    component: CodeFieldStoryComponent,
    argTypes: {},
} satisfies Meta<typeof CodeFieldStoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Basic: Story = {
    args: {},
};
